export enum EEnvironments {
  Development = 'development',
  Local = 'local',
  Production = 'production',
}
